<template>
  <div>
  </div>
</template>

<script>
import GraphqlAPI from '../../../utils/GraphqlAPI'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj => {
    const arr = Object.keys(obj).map(key => {
      if (obj[key] instanceof Array) {
        const courseArry = obj[key]
        const arr2 = courseArry.map(obj2 => {
          const objStr = Object.keys(obj2).map(key2 => {
            if (obj2[key2] === 0 || obj2[key2]) {
              if (typeof obj2[key2] === 'number' || typeof obj2[key2] === 'boolean') {
                return `${key2}: ${obj2[key2]}`
              } else {
                return `${key2}: "${obj2[key2]}"`
              }
            }
          })
          return `{${objStr.join(', ')}}`
        })
        const arr2str = `[${arr2.join(', ')}]`
        return `${key}: ${arr2str}`
      } else if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
        return `${key}: ${obj[key]}`
      } else if (obj[key]) {
        return `${key}: ${JSON.stringify(obj[key])}`
      }
    })
    return `{${arr.join(', ')}}`
  })
  return `[${resArry.join(', ')}]`
}

const toCourseInt = (value) => {
  if (value == null || value === '') {
    return null
  }
  const parsed = parseInt(value, 10)
  return Number.isNaN(parsed) ? null : parsed
}

const convertObjString = (obj) => {
  const arr = Object.keys(obj).map((key) => {
    if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
      return `${key}: ${obj[key]}`
    }
  })
  return `{${arr.join(',')}}`
}

const saveResultMutation = (campaignId, dailyResultInputList, saveResultInputOption) => `
  mutation saveResult {
    saveResult(
      input: {
        campaign_id: "${campaignId}",
        daily_result: ${convertArrayString(dailyResultInputList)},
        save_result_option: ${convertObjString(saveResultInputOption)}
      }
    )
  }
`
const saveResult = async (campaignId, dailyResultInputList, saveResultInputOption) => {
  const { data: { saveResult: data } } = await GraphqlAPI(saveResultMutation(campaignId, dailyResultInputList, saveResultInputOption))
  return data
}

export default {
  props: [
    'dailyValueList',
    'campaignUser',
    'isSubmitting',
    'stepCountIntegrateCourseId',
    'weightIntegrateCourseId',
    'bloodPressureIntegrateCourseId'
  ],
  data () {
    return {
      accessToken: null,
      targetDateList: []
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async mounted () {
    const walkingPointList = this.$store.getters.getWalkingPointListFromMobileApp
    const weightList = this.$store.getters.getWeightListFromMobileApp
    const bloodPressureList = this.$store.getters.getBloodPressureListFromMobileApp
    if (walkingPointList.length || weightList.length || bloodPressureList.length) {
      await this.saveData(walkingPointList, weightList, bloodPressureList)
    }
  },
  methods: {
    async saveData (walkingPointList, weightList, bloodPressureList) {
      this.$emit('saveMobileAppHealthDataSubmitting', true)
      const updateDailyValueList = []
      const processSteps = this.stepCountIntegrateCourseId && walkingPointList.length
      const processWeight = this.weightIntegrateCourseId && weightList.length
      const processBloodPressure = this.bloodPressureIntegrateCourseId && bloodPressureList.length

      // 対象コース・連携データがない場合、ヘルスデータ自動保存必要フラグをFalseに
      if (!processSteps && !processWeight && !processBloodPressure) {
        this.$emit('saveMobileAppHealthDataSubmitting', false)
        this.$store.dispatch('setNeedsSaveHealthDataFromMobileApp', false)
        return
      }

      this.dailyValueList.forEach(elm => {
        const stepCourse = this.stepCountIntegrateCourseId
          ? elm.select_course_result.find(cr => cr.course_id === this.stepCountIntegrateCourseId)
          : null
        const weightCourse = this.weightIntegrateCourseId
          ? elm.select_course_result.find(cr => cr.course_id === this.weightIntegrateCourseId)
          : null
        const bloodPressureCourse = this.bloodPressureIntegrateCourseId
          ? elm.select_course_result.find(cr => cr.course_id === this.bloodPressureIntegrateCourseId)
          : null

        const integrateCourses = [stepCourse, weightCourse, bloodPressureCourse].filter(Boolean)
        // 連携コースがすべて手動入力の場合、上書き用日次データを作成しない。
        if (integrateCourses.length > 0 && integrateCourses.every(cr => cr.is_manual)) {
          return
        }

        const walkingPoint = processSteps && stepCourse && !stepCourse.is_manual
          ? walkingPointList.find(item => item.date === elm.date)
          : undefined
        const weight = processWeight && weightCourse && !weightCourse.is_manual
          ? weightList.find(item => item.date === elm.date)
          : undefined
        const bloodPressure = processBloodPressure && bloodPressureCourse && !bloodPressureCourse.is_manual
          ? bloodPressureList.find(item => item.date === elm.date)
          : undefined

        const applySteps = Boolean(walkingPoint && walkingPoint.point)
        const applyWeight = Boolean(weight && weight.weight_kg)
        const applyBloodPressure = Boolean(
          bloodPressure && (bloodPressure.top_blood_pressure || bloodPressure.bottom_blood_pressure)
        )

        // 上書き対象のモバイルデータが1つもない（0・null・undefined 等は対象外）
        if (!applySteps && !applyWeight && !applyBloodPressure) {
          return
        }

        // 更新対象
        const filteredCourseList = []
        for (const ce of elm.select_course_result) {
          if (applySteps && ce.course_id === this.stepCountIntegrateCourseId) {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: null,
              integer: walkingPoint.point,
              number: null,
              dual_integer_1: null,
              dual_integer_2: null,
              is_manual: false
            })
          } else if (applyWeight && ce.course_id === this.weightIntegrateCourseId) {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: null,
              integer: null,
              number: parseFloat(weight.weight_kg),
              dual_integer_1: null,
              dual_integer_2: null,
              is_manual: false
            })
          } else if (applyBloodPressure && ce.course_id === this.bloodPressureIntegrateCourseId) {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: null,
              integer: null,
              number: null,
              dual_integer_1: toCourseInt(bloodPressure.top_blood_pressure),
              dual_integer_2: toCourseInt(bloodPressure.bottom_blood_pressure),
              is_manual: false
            })
          } else {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: ce.circle_and_cross,
              integer: (ce.integer === 0 || ce.integer) ? parseInt(ce.integer) : null,
              number: (ce.number === 0 || ce.number) ? parseFloat(ce.number) : null,
              dual_integer_1: (ce.dual_integer_1 === 0 || ce.dual_integer_1) ? parseInt(ce.dual_integer_1) : null,
              dual_integer_2: (ce.dual_integer_2 === 0 || ce.dual_integer_2) ? parseInt(ce.dual_integer_2) : null
            })
          }
        }
        const newDv = {}
        if (elm.top_blood_pressure || elm.bottom_blood_pressure || elm.note || (filteredCourseList && filteredCourseList.length > 0)) {
          newDv.date = elm.date
          newDv.top_blood_pressure = elm.top_blood_pressure ? parseInt(elm.top_blood_pressure) : null
          newDv.bottom_blood_pressure = elm.bottom_blood_pressure ? parseInt(elm.bottom_blood_pressure) : null
          newDv.note = elm.note ? elm.note : null
          newDv.select_course_result = filteredCourseList
          updateDailyValueList.push(newDv)
        }
      })

      // 更新対象がない場合、ヘルスデータ自動保存必要フラグをFalseに
      if (updateDailyValueList.length === 0) {
        this.$emit('saveMobileAppHealthDataSubmitting', false)
        this.$store.dispatch('setNeedsSaveHealthDataFromMobileApp', false)
        return
      }

      try {
        const saveResultInputOption = {}
        // アプリ利用フラグ、アプリ用mobile_app_last_signin_at更新を含める
        saveResultInputOption.is_mobile_app_used = true
        const saveResultResponse = await saveResult(this.campaign.id, updateDailyValueList, saveResultInputOption)
        // 保持データの更新
        this.$emit('refreshFromSaveMobileAppHealthData', saveResultResponse)
      } catch (e) {
        this.$emit('inputErrorFromSaveMobileAppHealthData', '結果記録の保存に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      } finally {
        // 保存終わったらフラグ更新（もう一度開いても保存処理をさせない）
        this.$store.dispatch('setNeedsSaveHealthDataFromMobileApp', false)
        // 通常版、継続版、両方保存不要の場合、クリア
        if (!this.$store.getters.getNeedsSaveHealthDataFromMobileApp && !this.$store.getters.getNeedsSaveHealthDataFromMobileAppRelational) {
          this.$store.dispatch('setWalkingPointListFromMobileApp', [])
          this.$store.dispatch('setWeightListFromMobileApp', [])
          this.$store.dispatch('setBloodPressureListFromMobileApp', [])
        }
      }
    }
  }
}
</script>
